











import {Component, Prop, Vue, Inject, Watch} from 'vue-property-decorator';
import CSimpleTable from '@/components/base/table/CSimpleTable.vue';
import FlexGridTableHead from './FlexGridTableHead.vue';
import FlexGridTableBody from './FlexGridTableBody.vue';
import FlexGridModel from '@/models/FlexGridModel';

/**
 *  @requires ./FlexGridTableHead.vue
 *  @requires ./FlexGridTableBody.vue
 */
@Component({
    components: {
        CSimpleTable,
        FlexGridTableHead,
        FlexGridTableBody,
    },
})
export default class FlexGridTable extends Vue {
    @Inject() moduleName!: string;

    private tableFixedHeight: string | null = null;
    private resizeTimeoutID: any = null;

    get compressed(): boolean {
        return this.$store.state[this.moduleName].compressed;
    }
    get mainData(): FlexGridModel | null {
        return this.$store.state[this.moduleName].data;
    }

    get isNeedFixCellsHorizontally() {
        return typeof this.mainData?.Config.CountAnchoredColumns === 'number';
    }

    @Watch('compressed')
    onCompressedChange(value: boolean, oldValue: boolean | undefined) {
        if (value) {
            this.tableFixedHeight = this.getTableCompressedHeight() + 'px';
            if (oldValue !== undefined) this.scrollTo();
        } else {
            this.tableFixedHeight = null;
        }
        this.fixStickyCells();
    }

    created() {
        window.addEventListener('resize', this.windowResizer);
    }
    destroyed() {
        window.removeEventListener('resize', this.windowResizer);
    }

    windowResizer() {
        if (this.resizeTimeoutID) clearTimeout(this.resizeTimeoutID);
        this.resizeTimeoutID = setTimeout(async () => {
            this.fixStickyCells();
        }, 50);
    }

    getTableCompressedHeight() {
        const navbar = document.querySelector('.v-app-bar') as HTMLElement,
            flexHeader = this.$parent.$el.querySelector('.flex-grid-header') as HTMLElement,
            flexFooter = this.$parent.$el.querySelector('.flex-grid-footer') as HTMLElement;
        return (
            document.documentElement.clientHeight -
            navbar.offsetHeight -
            flexHeader.offsetHeight -
            flexFooter.offsetHeight -
            25
        );
    }
    scrollTo() {
        (this.$parent.$el as HTMLElement).scrollIntoView(true);
        window.scrollBy(0, -50);
    }

    async fixStickyCells() {
        if (!(this.$refs.table as any)?.$el) {
            this.$nextTick().then(() => {
                this.fixStickyCells();
            });
            return;
        }
        await this.$nextTick();

        const thCollection = Array.from(this.$el.querySelectorAll('thead th')) as HTMLElement[];
        if (this.compressed) {
            thCollection.forEach(th => {
                th.style.top = '';
                th.classList.add('sticky');
                th.style.top = th.offsetTop + 'px';
                th.style.background = '#fff';
            });
        } else {
            thCollection.forEach(th => {
                if (!th.classList.contains('sticky-column') && !th.classList.contains('sticky-actions'))
                    th.classList.remove('sticky');
                th.style.top = '';
                th.style.background = '';
            });
        }

        let rows = Array.from(this.$el.querySelectorAll('thead tr')) as HTMLElement[];
        rows.forEach(row => {
            let ths = Array.from(row.querySelectorAll('th')) as HTMLElement[];
            ths.forEach((th, index, array) => {
                if (this.isNeedFixCellsHorizontally && index === 0 && th.classList.contains('sticky-column')) {
                    th.style.left = '';
                    th.style.left = th.offsetLeft + 'px';
                } else if (this.isNeedFixCellsHorizontally && th.classList.contains('sticky-column')) {
                    let leftSibling = array[index - 1];
                    th.style.left = '';
                    th.style.left = leftSibling.clientWidth + parseFloat(leftSibling.style.left) + 'px';
                } else {
                    th.style.left = '';
                    th.classList.remove('sticky-column');
                }
            });
        });

        rows = Array.from(this.$el.querySelectorAll('tbody tr')) as HTMLElement[];
        rows.forEach(row => {
            let tds = Array.from(row.querySelectorAll('td')) as HTMLElement[];
            tds.forEach((td: HTMLElement, index, array) => {
                if (this.isNeedFixCellsHorizontally && index === 0 && td.classList.contains('sticky')) {
                    td.style.left = '';
                    td.style.left = td.offsetLeft + 'px';
                } else if (this.isNeedFixCellsHorizontally && td.classList.contains('sticky')) {
                    let leftSibling = array[index - 1];
                    td.style.left = leftSibling.clientWidth + parseFloat(leftSibling.style.left) + 'px';
                } else {
                    td.style.left = '';
                    td.classList.remove('sticky-column');
                }
            });
        });
    }

    onUpdateFixCells() {
        this.fixStickyCells();
    }
}
